<script setup lang="ts">
import { MtdButton, MtdTypography } from '@paygine/mtd-uikit'
import { ref, useTemplateRef } from 'vue'

import type { Steps } from '@/shared/constants'

import { type userDataApi } from '@/entities/user-data'
import { carNumberModel, VCarNumber } from '@/entities/v-car-number'
import { useTransport } from '@/features/transport'
const emit = defineEmits<{
    goto: [Steps]
}>()

const { addTransport, isLoading } = useTransport()

type CurrentCar = null | Partial<userDataApi.Grn>

const externalError = ref<carNumberModel.ExternalError>({})
const currentCar = ref<CurrentCar>(null)
const carNumberRef = useTemplateRef<InstanceType<typeof VCarNumber>>('car-number')

async function addCarNumber() {
    const grn = currentCar.value?.grn
    const grnCountry = currentCar.value?.grn_country

    if (!grn || !grnCountry) return
    if (!(await carNumberRef.value?.validate())) return

    const result = await addTransport({ grn, grn_country: grnCountry })

    if (result.success && result.id) {
        emit('goto', 'select-pay-method')
        return
    } else if (result.mask_phone) {
        externalError.value.alreadyLinkedPhone = result.mask_phone
        return
    }

    externalError.value.unknownError = true
}

function updateCarNumber(payload: { country: string; grn: string }) {
    currentCar.value = {
        grn: payload.grn,
        grn_country: payload.country,
    }
    externalError.value = {}
}
</script>

<template>
    <MtdTypography
        variant="header-6"
        class="default-layout__title"
        tag="h1"
        >Введите госномер автомобиля
    </MtdTypography>

    <div class="mt-24">
        <VCarNumber
            ref="car-number"
            :external-error="externalError"
            :enable-variants-select="true"
            @car-number:update="updateCarNumber"
        />
    </div>

    <MtdButton
        class="mt-32"
        :is-loading="isLoading"
        @click="addCarNumber"
        >Далее</MtdButton
    >
</template>
